module.exports = __webpack_public_path__ + "assets/img/edit_item.c60f059a.png";